import React from "react";
import "./ServicesSection.css";
import {
  FaBook,
  FaGraduationCap,
  FaClipboardList,
  FaFileAlt,
} from "react-icons/fa";

const services = [
  {
    icon: <FaFileAlt size={30} />,
    title: "Article Publication",
    description: "We publish articles and research papers.",
  },
  {
    icon: <FaBook size={30} />,
    title: "Books Publication",
    description: "We publish books for the society.",
  },
  {
    icon: <FaGraduationCap size={30} />,
    title: "Research & Paper",
    description: "We publish research papers & theories.",
  },
  {
    icon: <FaClipboardList size={30} />,
    title: "Certification",
    description: "Authorized by the Indian Government.",
  },
];

const ServicesSection = () => {
  return (
    <section className="services-section">
      <div className="container">
        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-md-6 col-lg-3">
              <div className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h5>{service.title}</h5>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
